// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".font-xs[data-v-0cbf178c]{font-size:.75rem}.btn-link[data-v-0cbf178c]{border-style:none!important;background:transparent;padding:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
